function showStickyNav() {
    const stickyFpaNav = $('#stickyDescription');
    const scrollHeight = $(".backToPV").height() + $(".carzHeaderWrap").height() + $(".siteWideMessages").height() + $(".item").height();

    if (stickyFpaNav.length > 0) {
        if (stickyFpaNav.offset().top > scrollHeight) {
            stickyFpaNav.addClass("active");
        } else {
            stickyFpaNav.removeClass("active");
        }
    }
}

$(document).ready(function () {
    showStickyNav();

    $(window).scroll(function() {
        showStickyNav();
    });
});


